import { BaseUrl } from "../../BaseUrl/BaseUrl";
import {
    getApiWithAuthorization,
    postApiWithoutAuthorization,
} from "../ApiMethod/ApiMethod";

export const StateLookupList = async (countryID) => {
    const url = `${BaseUrl}/State?CountryID=${countryID}`;
    const res = await getApiWithAuthorization(url);
    return res;
};
export const CityLookupList = async (cityID) => {
    let url;
    if (cityID === null) {
        url = `${BaseUrl}/City?StateID=`;
    } else {
        url = `${BaseUrl}/City?StateID=${cityID}`;
    }
    const res = await getApiWithAuthorization(url);
    return res;
};
export const CountryLookupList = async () => {
    const url = `${BaseUrl}/Country`;
    const res = await getApiWithAuthorization(url);
    return res;
};